import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "./Reveal";
import { LANDING } from "@/data/pageCopy";


const { kicker, h2, chapters } = LANDING.manifesto;

export const Manifesto = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section id="why" ref={ref} className="relative py-24 md:py-32 bg-[#0a0a0a] text-white" data-testid="why-section">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 grid lg:grid-cols-[1fr_0.9fr] gap-14">
        <div>
          <Reveal>
            <p className="font-mono-t text-xs uppercase tracking-[0.25em] text-[#5B8CFF] mb-4">{kicker}</p>
            <h2 className="font-heading font-medium tracking-tight text-3xl md:text-4xl lg:text-5xl max-w-xl">
              {h2}
            </h2>
          </Reveal>

          <div className="mt-12 divide-y divide-white/10 border-t border-white/10">
            {chapters.map((c, i) => (
              <Reveal key={c.n} delay={i * 0.08}>
                <div className="py-8 grid grid-cols-[auto_1fr] gap-6 group">
                  <span className="font-heading font-medium text-3xl text-white/20 group-hover:text-white transition-colors">{c.n}</span>
                  <div>
                    <h3 className="font-heading font-semibold text-xl md:text-2xl">{c.title}</h3>
                    <p className="mt-3 text-neutral-400 text-sm md:text-base leading-relaxed max-w-lg">{c.body}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        {/* clipped infrastructure image with parallax */}
        <div className="relative hidden lg:block">
          <div className="sticky top-28 overflow-hidden border border-white/10 h-[560px]">
            <motion.img
              style={{ y: imgY, scale: 1.15 }}
              src="https://images.pexels.com/photos/5489456/pexels-photo-5489456.jpeg"
              alt="Carrier-grade server infrastructure"
              className="w-full h-full object-cover grayscale contrast-125"
              data-testid="why-image"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a] via-transparent to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-6 border-t border-white/10 bg-black/50 backdrop-blur-sm">
              <p className="font-mono-t text-[11px] uppercase tracking-widest text-white/70">Owned infrastructure</p>
              <p className="font-heading font-semibold text-lg mt-1">Real carrier-grade telephony.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
